import { Box, Grid2 } from '@mui/material'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { GET_ESCALATION_COLOR } from '../../constants/SeverityColors';
dayjs.extend(customParseFormat)


export default function TimelineItem({ date, content, rating }: { date: string, content: string, rating: string }) {
    return (
        <Grid2
            className="timeline_item"
            sx={{
                width: '100%',
                minHeight: '50px',
                display: 'grid',
                gridTemplateColumns: '5vw 1vw 1fr',
                gap: 2,
                '&:first-of-type': {
                    marginTop: 0.25,
                },
                '&:last-of-type': {
                    marginBottom: 0.25,
                    '& .timeline_item_middle::after': {
                        height: 'calc(100% - 1.75vw) !important'
                    }
                }
            }}>
            <Box>
                {dayjs(date, "DD-MM-YYYY").format('DD/MM/YYYY')}
            </Box>
            <Box className={"timeline_item_middle"} sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginRight: 1,
                position: 'relative',
                '&::before': {
                    content: '" "',
                    position: 'absolute',
                    zIndex: 1,
                    top: 0,
                    width: '1.5ch',
                    aspectRatio: 1 / 1,
                    marginTop: 0.375,
                    background: GET_ESCALATION_COLOR(rating),
                    borderRadius: 10,
                    boxShadow: `0 0 0px 2px ${GET_ESCALATION_COLOR(rating)}`
                },
                '&::after': {
                    content: '" "',
                    position: 'relative',
                    top: '0.75vw',
                    width: 2,
                    height: '100%',
                    background: GET_ESCALATION_COLOR(rating),
                }
            }}></Box>
            <Box sx={{
                paddingBottom: 3,
            }}>
                {content}
            </Box>
        </Grid2>
    )
}
